export const enum EoiTemplateGroups {
  BUYER_DETAILS = "Buyer details",
  BUYER_DETAILS_2 = "Buyer 2 details",
  DEFAULT_GROUP = "default_group",
  SOLICITOR_DETAILS = "Solicitor Details",
  CONTRACT_CONDITIONS = "Contract Conditions",
  PURCHASE_AS_COMPANY_DETAILS = "Purchase as company details",
}
